// src/components/Chat/clientChannels.ts

/** Каналы связи клиента: ровно те значения, которые принимает бэкенд. */
export const CLIENT_CHANNELS: ReadonlyArray<{ value: string; label: string }> = [
    { value: 'phone', label: 'Телефон' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'telegram', label: 'Telegram' },
    { value: 'vk', label: 'VK' },
    { value: 'avito', label: 'Avito' },
    { value: 'orion', label: 'ORION' },
];

/** Подпись канала для карточки; неизвестное значение показываем как есть. */
export const channelLabel = (value?: string | null): string => {
    if (!value) return '';

    const known = CLIENT_CHANNELS.find((item) => item.value === value);

    return known ? known.label : value;
};
